<template>
    <div class="BasicPersonDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.FirstName + ' ' + props.rowData.LastName"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddContact()" class="pointer olive-green-text" />
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-contact" :title="ModalContactTitle"  hide-footer>
            <b-container v-if="EditMode == false && TargetRecord.Id">
                <b-row>
                    <b-col>
                        <h3>Name</h3>
                        <p><span class="bold">First Name: </span>{{ TargetRecord.FirstName }}</p>
                        <p><span class="bold">Last Name: </span>{{ TargetRecord.LastName }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <p v-if="TargetRecord.Email"><span class="bold">Email: </span><a :href="'mailto:' + TargetRecord.Email"> {{ TargetRecord.Email }} </a></p>
                        <p v-if="IsChurchContact"><span class="bold">Notify of Hostings: </span> {{ convertBoolToYesNo(TargetRecord.NotifyOfHostings) }} </p>
                        <p v-for="(phoneNumber, phoneIndex) in TargetRecord.PhoneNumbers">
                            <span class="bold">{{ phoneNumber.PhoneType }}: </span>{{ phoneNumber.FormattedPhoneNumber }} {{ phoneNumber.Description ? '(' + phoneNumber.Description + ')' : '' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Assignment Details</h3>
                        <p><span class="bold">Contact Type: </span>{{ TargetRecord.Category }}</p>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetRecord.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetRecord.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelContact()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="CreateUpdateRecord">
                    <b-row>
                        <b-col>
                            <h3>Name</h3>
                            <div class="form-group">
                                <label>First Name:</label>
                                <input class="form-control" v-model="TargetRecord.FirstName" />
                            </div>
                            <div class="form-group">
                                <label>Last Name:</label>
                                <input class="form-control" v-model="TargetRecord.LastName" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Contact Info</h3>
                            <div class="form-group">
                                <label>Email:</label>
                                <input class="form-control" v-model="TargetRecord.Email" />
                            </div>
                            <div class="form-group" v-if="IsChurchContact">
                                <label>Notify of Hostings?:</label>
                                <select class="form-control" v-model="TargetRecord.NotifyOfHostings" >
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Phone Numbers <font-awesome-icon :icon="['fa', 'plus']" v-on:click="AddNewPhoneNumber()" class="pointer olive-green-text" /> </h3>

                            <div v-for="(phoneNumber, phoneIndex) in TargetRecord.PhoneNumbers">
                                <p class="bold">Phone #{{ phoneIndex + 1 }}: <font-awesome-icon :icon="['fa', 'trash-alt']" v-on:click="DeletePhoneNumber(phoneIndex)" class="pointer red" /></p>
                                <div class="form-group">
                                    <label>Phone Number:</label>
                                    <input class="form-control" v-model="phoneNumber.PhoneNumber" required />
                                </div>
                                <div class="form-group">
                                    <label>Type:</label>
                                    <select class="form-control" v-model="phoneNumber.PhoneType" required>
                                        <option value="Cell">Cell</option>
                                        <option value="Home">Home</option>
                                        <option value="Work">Work</option>
                                        <option value="Google">Google</option>
                                        <option value="Fax">Fax</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Description:</label>
                                    <input class="form-control" v-model="phoneNumber.Description" />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetRecord.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelContact()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteRecord()" type="button" v-if="TargetRecord.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "GetEndpoint",
            "GetPayload",
            "CreateUpdateEndpoint",
            "CreateUpdatePayload",
            "DeleteEndpoint",
            "IsChurchContact"
        ],
        data: function () {
            return {
                TargetRecord: {},
                ModalContactTitle: "",
                LoadedRecords: [],//Contact Membership Records
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                },
                
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            //API
            GetRecords() {
                this.$MasterAPI.ExecuteRequest("GET", this.GetEndpoint, this.GetPayload, this.GetRecordsSuccess, () => { }, false);
            },
            GetRecordsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            CreateUpdateRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", this.CreateUpdateEndpoint, { ...this.TargetRecord, ...this.CreateUpdatePayload }, this.CreateUpdateRecordSuccess, () => { }, true);
            },
            CreateUpdateRecordSuccess(response) {
                this.GetRecords();
                this.$refs['modal-contact'].hide();
            },
            DeleteRecord() {
                this.$MasterAPI.ExecuteRequest("DELETE", this.DeleteEndpoint + "/" + this.TargetRecord.Id, {}, this.DeleteRecordSuccess, () => { }, true);
                this.$refs
            },
            DeleteRecordSuccess() {
                this.GetRecords();
                this.$refs['modal-contact'].hide();
            },
            //UI
            ShowDetailView(record) {
                this.TargetRecord = JSON.parse(JSON.stringify(record));
                
                if (this.EditMode) {
                    this.ModalContactTitle = "Editing " + record.FirstName + " " + record.LastName;
                } else {
                    this.ModalContactTitle = "Viewing " + record.FirstName + " " + record.LastName;
                }
                this.$refs["modal-contact"].show();
            },
            ShowAddContact() {
                this.TargetRecord = {
                    PhoneNumbers: []
                }
                this.ModalContactTitle = "Add New Person";
                this.$refs["modal-contact"].show();
            },
            CancelContact() {
                this.$refs['modal-contact'].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            convertBoolToYesNo(value) {
                if (value == true) {
                    return "Yes";
                } else if (value == false) {
                    return "No";
                } else {
                    return "";
                }
            },
            AddNewPhoneNumber() {
                this.TargetRecord.PhoneNumbers.push({
                    Id: null,
                    PhoneNumber: "",
                    PhoneType: "",
                    Description: ""
                });
            },
            DeletePhoneNumber(phoneIndex) {
                this.TargetRecord.PhoneNumbers.splice(phoneIndex, 1);
            }
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableData: function () {
                return this.LoadedRecords;
            },
            TableFields: function () {
                let initialFields = [
                    {
                        name: '__slot:DetailView',
                        title: 'NAME',
                    },
                    {
                        name: 'StartDate',
                        title: 'STARTED',
                        callback: 'formatDate|MM/DD/YY'
                    },
                    {
                        name: 'EndDate',
                        title: 'ENDED',
                        callback: 'formatDate|MM/DD/YY'
                    },
                ]

                if (this.IsChurchContact) {
                    initialFields.push({
                        name: 'NotifyOfHostings',
                        title: "NOTIFY OF HOSTINGS",
                        callback: 'convertBoolToYesNo'
                    });
                }

                return initialFields;
            }
        },
        mounted() {
            this.GetRecords();
        },

    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>